import { VList } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import infoCardThemeBlue from '../../../themes/infoCardThemeBlue'
import InfoCard from './InfoCard/InfoCard'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({
  align: LAYOUT_ALIGN.STRETCH,
  spacing: 1.25,
})``

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const InfoCards = ({ cards }) => (
  <Layout>
    {renderList(
      (props) => (
        <ThemeProvider theme={infoCardThemeBlue}>
          <InfoCard {...props} />
        </ThemeProvider>
      ),
      cards
    )}
  </Layout>
)

InfoCards.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default InfoCards
